/* ==========================================================================
   PWR DEALER
   ----------------------------------------------------------------------------
   The ONE behaviour needed beyond the engine: a stat count-up that PRESERVES
   prefix/suffix (e.g. "500+", "1M+", "98%") and skips non-numeric values.

   Why not the engine's [data-pwr-countup]? It overwrites textContent with the
   bare number, dropping "+"/"%"/"M" and zeroing non-numeric text. Partnership
   stats are almost always suffixed, so this controller uses its own hook,
   data-pwr-stat, and formats around it. This mirrors the pwr-story pattern —
   same proven approach, section-scoped — rather than duplicating the engine.

   Reused, NOT reimplemented:
     - Fade / cascade      -> engine [data-pwr-reveal] / -group
     - Icons / button / CTA -> pwr-icon / pwr-button (in markup)
     - Lifecycle / utils    -> JS Core (registerSection, utils)

   Registered via PWR.registerSection => Theme Editor safe, no double init.
   Reduced motion / no observer => values settle immediately.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.PWR || !window.PWR.registerSection) return;
  var PWR = window.PWR;
  var utils = PWR.utils;
  var Section = PWR.Section;

  function Dealer(root) {
    Section.call(this, root);
  }
  Dealer.prototype = Object.create(Section.prototype);
  Dealer.prototype.constructor = Dealer;

  Dealer.prototype.init = function () {
    this.stats = this.$$('[data-pwr-stat]');
    if (!this.stats.length) return;

    if (utils.prefersReducedMotion() || !('IntersectionObserver' in window)) {
      for (var i = 0; i < this.stats.length; i++) this._settle(this.stats[i]);
      return;
    }

    var self = this;
    this._io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        self._run(entry.target);
        self._io.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    this.stats.forEach(function (el) { self._io.observe(el); });
    this.addCleanup(function () { if (self._io) self._io.disconnect(); });
  };

  /* "1M+" -> {value:1, prefix:'', suffix:'M+'}; "98%" -> {value:98, suffix:'%'};
     "Premium" -> {value:null}. */
  Dealer.prototype._parse = function (el) {
    var raw = (el.getAttribute('data-pwr-stat') || el.textContent || '').trim();
    var match = raw.match(/^(\D*)(\d[\d,]*)(.*)$/);
    if (!match) return { value: null, raw: raw };
    return {
      value: parseInt(match[2].replace(/,/g, ''), 10),
      prefix: match[1] || '',
      suffix: match[3] || '',
      raw: raw
    };
  };

  Dealer.prototype._format = function (n) {
    try { return n.toLocaleString(); } catch (e) { return String(n); }
  };

  Dealer.prototype._settle = function (el) {
    var p = this._parse(el);
    el.textContent = p.value === null ? p.raw : p.prefix + this._format(p.value) + p.suffix;
  };

  Dealer.prototype._run = function (el) {
    var p = this._parse(el);
    if (p.value === null) { el.textContent = p.raw; return; }

    var duration = parseInt(el.getAttribute('data-duration'), 10) || 1200;
    var start = performance.now();
    var self = this;
    var tick = function (now) {
      var t = utils.clamp((now - start) / duration, 0, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = p.prefix + self._format(Math.round(p.value * eased)) + p.suffix;
      if (t < 1) window.requestAnimationFrame(tick);
    };
    window.requestAnimationFrame(tick);
  };

  PWR.registerSection('pwr-dealer', function (root) { return new Dealer(root); });
})();
